import { render, staticRenderFns } from "./menu-groups.vue?vue&type=template&id=4293bc42&scoped=true&"
import script from "./menu-groups.vue?vue&type=script&lang=js&"
export * from "./menu-groups.vue?vue&type=script&lang=js&"
import style0 from "./menu-groups.vue?vue&type=style&index=0&id=4293bc42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4293bc42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4293bc42')) {
      api.createRecord('4293bc42', component.options)
    } else {
      api.reload('4293bc42', component.options)
    }
    module.hot.accept("./menu-groups.vue?vue&type=template&id=4293bc42&scoped=true&", function () {
      api.rerender('4293bc42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/menu/menu-groups.vue"
export default component.exports